const SessionStorageService = (function () {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _setShowReloadLastSearchModal(isShown) {
    return sessionStorage.setItem("showReloadLastSearchModal", JSON.stringify(isShown));
  }

  function _getShowReloadLastSearchModal() {
    return JSON.parse(sessionStorage.getItem("showReloadLastSearchModal"));
  }

  // End of the above code
  return {
    getService: _getService,
    getShowReloadLastSearchModal: _getShowReloadLastSearchModal,
    setShowReloadLastSearchModal: _setShowReloadLastSearchModal,
  };
})();
export default SessionStorageService;
